var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v(" Développeur "),_c('span',{staticClass:"typed-text"},[_vm._v(_vm._s(_vm.typeValue))]),_c('span',{staticClass:"cursor",class:{ typing: _vm.typeStatus }})])])}
var staticRenderFns = []

export { render, staticRenderFns }